import React from "react";
import { CtaButton } from "../CtaButton";
import { CountdownTimer } from "../CountdownTimer";
import { images } from "../../data/content";
const stats = [{
  value: "6",
  label: "Premium clinical volumes"
}, {
  value: "5",
  label: "Exclusive bonuses"
}, {
  value: "30+",
  label: "Decision tools"
}];
export function Hero() {
  const mockup = <img src={images.mockup} alt="Mandibular Complete Denture Blueprint 6-volume collection with 5 bonuses and clinical decision tools" className="mx-auto w-full max-w-[560px] drop-shadow-[0_30px_40px_rgba(0,0,0,0.45)]" data-id="element-208" data-mp="hw8tlld63ll5" />;
  return <header className="relative overflow-hidden bg-navy-950 text-white" data-id="element-209" data-mp="vndoka5lbpp5">
      <div className="bg-gold-400 px-4 py-2.5 text-center text-[13px] font-bold text-navy-950 sm:text-sm" data-id="element-210" data-mp="10l5qlwzy8s72">
        Special digital edition · Today only $27 USD <span className="line-through opacity-60" data-id="element-211" data-mp="15mczjzdtvxfb">$396</span>
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 pb-14 pt-8 sm:px-6 sm:pt-12 lg:grid-cols-[1.05fr_1fr] lg:gap-12 lg:pb-20 lg:pt-16" data-id="element-212" data-mp="1ako7u5oh5zvf">
        <div data-id="element-213" data-mp="4optc945k57a">
          <p className="text-center font-display text-sm font-extrabold uppercase tracking-[0.12em] text-gold-400 lg:text-left" data-id="element-214" data-mp="4ozk3yx0uge1">
            Mandibular Complete Denture Blueprint™
          </p>
          <p className="mt-1 text-center text-sm text-white/70 lg:text-left" data-id="element-215" data-mp="3rtp6q59umut2">By Dr. Valeria Montes</p>

          <h1 className="mt-5 text-center font-display text-[30px] font-black leading-[1.12] sm:text-4xl lg:text-left lg:text-[50px]" data-id="element-216" data-mp="se0x7zgsufpn">
            Organize Your Most Challenging Lower Denture Cases{" "}
            <span className="text-gold-400" data-id="element-217" data-mp="inz9j8scyzb9">in Just 15 Minutes</span>
          </h1>
          <p className="mt-4 text-center text-lg font-semibold text-white/90 sm:text-xl lg:text-left" data-id="element-218" data-mp="emvsiiykqx8g">
            Without guesswork or endless trial-and-error adjustments.
          </p>

          <div className="mt-8 lg:hidden" data-id="element-219" data-mp="1b6mr4e85bw7l">{mockup}</div>

          <p className="mt-8 text-center text-base leading-relaxed text-white/75 sm:text-lg lg:text-left" data-id="element-220" data-mp="16da1q1vn7lds">
            A step-by-step clinical decision-making system designed to help dental professionals evaluate mandibular
            anatomy, identify factors affecting denture stability and retention, plan functional impressions, and
            organize treatment decisions with greater confidence.
          </p>

          <dl className="mt-8 grid grid-cols-3 divide-x divide-white/15 rounded-2xl bg-white/[0.06] py-4 ring-1 ring-white/10" data-id="element-221" data-mp="2vte1zijzbpuj">
            {stats.map(s => <div key={s.label} className="px-2 text-center" data-id="element-222" data-mp="2muslru1zcmwx">
                <dt className="sr-only" data-id="element-223" data-mp="27x9o227bqzdc">{s.label}</dt>
                <dd className="font-display text-3xl font-black text-gold-400 sm:text-4xl" data-id="element-224" data-mp="27yjo2wxqmhmm">{s.value}</dd>
                <dd className="mt-1 text-xs font-medium leading-tight text-white/75 sm:text-sm" data-id="element-225" data-mp="2cwuzhc3ol06y">{s.label}</dd>
              </div>)}
          </dl>

          <div className="mt-9" data-id="element-226" data-mp="b5hwisl9x2dj">
            <CtaButton id="hero-cta" label="Get the Mandibular Complete Denture Blueprint™ now" data-id="element-227" data-mp="b3opvdanui5j" />
            <p className="mt-4 text-center text-sm font-medium text-white/75" data-id="element-228" data-mp="1vnsggnelewga">
              Instant digital access · One-time payment of $27 USD · Lifetime access
            </p>
          </div>

          <div className="mt-8" data-id="element-229" data-mp="25dlqhjz373if">
            <CountdownTimer tone="dark" data-id="element-230" data-mp="25ewu9jsj8b9j" />
          </div>
          <p className="mt-4 text-center text-xs text-white/55" data-id="element-231" data-mp="20l2bcikr40bi">
            All prices are displayed in US dollars. Currency is converted automatically to your local currency at
            checkout.
          </p>
        </div>

        <div className="hidden lg:block" data-id="element-232" data-mp="2abn9y60fd4uf">{mockup}</div>
      </div>
    </header>;
}